import { Object3DUtils } from '@3d-scene/common/util/object-3d-utils';
import { Mesh, MeshBasicMaterial, PlaneGeometry, Texture } from 'three';
import { ILayerElement } from '@3d-scene/layer/elements/i-layer-element';
import { MathUtils } from '@3d-scene/common/util/math-utils';
import { LabelElement } from '@3d-scene/layer/elements/label-element';

export class ImagePlaneElement extends Mesh implements ILayerElement {
  public layerElementType: string = 'ILayerElement';

  constructor(width: number, height: number, texture: Texture) {
    super(new PlaneGeometry(width, height));
    this.rotation.x = MathUtils.toRadians(LabelElement.DEFAULT_ROTATION.x);
    this.rotation.y = MathUtils.toRadians(LabelElement.DEFAULT_ROTATION.y);
    this.rotation.z = MathUtils.toRadians(LabelElement.DEFAULT_ROTATION.z);
    this.material = new MeshBasicMaterial({map: texture});
  }

  public dispose(): void {
    Object3DUtils.dispose(this);
  }
}
